import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "./../components/productslider.css"
import { FaShoppingBag, FaStar } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import { SiCssdesignawards } from "react-icons/si";
import { getRequest } from "../Auth/api";
import {Spin} from "antd"
import './../style/common.css'
import { Link } from 'react-router-dom';

const AussieProduct = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

const fetchProducts = async () => {
  try {
    const response = await getRequest("item");
    if (response?.data?.data?.length > 0) {
      const allItems = response.data.data;

      // Filter only items with category.name === 'Aussie breakfast'
      const aussieBreakfastItems = allItems.filter(
        (item) => item.category?.name?.trim().toLowerCase() === "aussie breakfast"
      );

      setProducts(aussieBreakfastItems);
    }
  } catch (error) {
    console.error("Failed to fetch products:", error.message);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchProducts();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    autoplay:800,
    swipeToSlide: true,
    responsive: [
       { breakpoint: 1370, settings: { slidesToShow: 3 } },
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="product-slider-section">
      {/* <p className="subheading">
        <SiCssdesignawards /> Lorem Ipsum Sub Heading
      </p> */}
      <h2 className="heading">Best Aussie Breakfast in Mandurah</h2>
      <div className="product-layer">
        <img
          src="/Images/Layer-2.webp"
          alt="Top Left Decor"
          className="decor-product"
          loading="lazy"
        />
      </div>

      {loading ? (
        <p style={{ textAlign: "center", padding: "2rem" }}>
          <Spin spinning={loading} tip="Loading items..."></Spin>
        </p>
      ) : (
        <Slider {...settings} className="product-slider">
          {products.map((item) => (
            <div className="product-card" key={item.id}>
              <img src={item.image_url} alt={item.name} loading="lazy"/>
              <div className="product-card-inner">
                <div className="card-text">
                  <h4>{item.name}</h4>
                  <div className="price">
                    {item.less_price && (
                      <span className="old">${item.less_price}</span>
                    )}
                    <span className="new">${item.price}</span>
                  </div>
                </div>  
                <div className="card-meta">
                  <div className="meta">
                    <FaShoppingBag className="bag" />
                    <span className="rating">
                      {item.rating} <FaStar className="star" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      )}

      <Link to="/view-our-menu">
  <button className="explore-btn">Explore All</button>
</Link>
    </div>
  );
};

export default AussieProduct;
